<template>
  <div class="data-card">
    <h2 v-if="title" :id="computedTitleId" class="data-card__title">{{ title }}</h2>
    <ul class="data-card__list">
      <li v-for="(item, i) in stats" :key="i" class="data-card__item">
        <div class="data-card__line">
          <div class="stat-info">
            <span class="data-card__value">
              {{ item.statValue }}
            </span>
            <span class="data-card__desc">{{ item.statDescription }}</span>
          </div>
          <span v-if="item.comparisonText" class="data-card__comparison">
            {{ item.comparisonText }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DataCuesCard',
  props: {
    title: String,
    stats: {
      type: Array,
      default: () => []
    },
    highlightColor: String,
    footNoteText: String,
    learnMoreText: String,
    learnMoreLink: String,
    isExternalLink: Boolean,
    titleId: {
      type: String,
      default: null
    }
  },
  computed: {
    computedTitleId() {
      return this.titleId || `data-card-title-${this._uid}`;
    }
  }
}
</script>

<style lang="scss" scoped src="./DataCuesCard.scss"></style>
